import { NgZone, OnInit, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { } from 'googlemaps';
import { User } from '../_models/index';
import { UserService, CookieService, MyCartService, IntroService } from '../_services/index';

declare var $: any;
declare var jQuery: any;
declare var gtag: Function;

@Component({
    moduleId: module.id,
    templateUrl: 'checkout.component.html',
    styleUrls: ['checkout.component.css']
})
export class CheckoutComponent implements OnInit {
    confirmInfo: string
    currentUser: User;
    users: User[] = [];
    username = "Username";
    customerId: string;
    orderConfirmation: string;
    cartData: any = [];
    credit: boolean;
    afterPaymentInfo: string;
    savedOrder: any;
    sessionKey: string;
    years = [];
    currentYear: number;
    currentMonth: number;
    invoiceStatus: string;
    invoiceOnly = 'N';
    months = ["01", "02", '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    tchecked = "N";
    constructor(private ngZone: NgZone, private router: Router, private userService: UserService, private cookieService: CookieService, private myCartService: MyCartService, private introService: IntroService, private gtmService: GoogleTagManagerService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // gtag('js', new Date());
                // gtag('config', 'UA-65756200-2');

                const gtmTag = {
                    event: 'Checkout Page URL',
                    pageName: event.url
                };

                this.gtmService.pushTag(gtmTag);
            }
        });
        if (this.cookieService.getCookie('customerName')) {
            this.username = this.cookieService.getCookie('customerName');
        }
        if (this.cookieService.getCookie('customerID')) {
            this.customerId = this.cookieService.getCookie('customerID');
        }

        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.username = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            this.LoadMyCart(this.username, this.sessionKey);
        }
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("invoiceStatus"))) {
            this.invoiceStatus = this.cookieService.getCookie('invoiceStatus');
            if (this.invoiceStatus != 'Y') {
                this.credit = true;
            }
        }
        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("invoiceOnly"))) {
            this.invoiceOnly = this.cookieService.getCookie('invoiceOnly');
            if (this.invoiceOnly == 'Y') {
                this.credit = false;
            }
        }
        let currentTime = new Date()
        let year = currentTime.getFullYear();
        this.currentYear = year;
        this.currentMonth = currentTime.getMonth();
        for (let i = 0; i < 10; i++) {
            this.years.push(year + i);
        }
        if (this.cookieService.getCookie('tchecked')) {
            this.tchecked = this.cookieService.getCookie('tchecked');
        }
    }

    LoadMyCart(customerId: string, skey: string) {
        this.myCartService.getcart(customerId, skey).subscribe(
            data => {
                this.cartData = data;
                this.cookieService.setCookieSession("cartCount", data.length);
                this.ngZone.run(() => {
                    setTimeout(function () {
                        $(function () {
                            $('#data-table').DataTable({
                                "pageLength": 50,
                                "lengthMenu": [[50, 100, 150, -1], [50, 100, 150, "All"]]
                            });
                            let table = $('#data-table').DataTable();
                            table
                                .order([3, 'desc'])
                                .draw();
                        });
                    }, 10)
                })
            }
        )
    }

    setDelay(customerId: string, orderid: string, delayed: string, skey: string) {
        this.myCartService.setdelay(customerId, orderid, delayed, skey).subscribe(result => this.confirmInfo = result,
            error => this.orderConfirmation = error);
    }

    deleteOrder(customerId: string, orderId: string, skey: string) {
        this.myCartService.removeorder(customerId, orderId, skey).subscribe(result => {
            this.confirmInfo = result;
            this.reload();
        },
            error => this.orderConfirmation = error);
    }

    reload() {
        this.ngZone.runOutsideAngular(() => {
            location.reload();
        });
    }

    placeorder(customerId: string, orderId: string, card: string, skey: string) {
        this.myCartService.placeorder(customerId, orderId, card, skey).subscribe(result => this.afterPaymentInfo = result,
            error => this.orderConfirmation = error);
    }

    getsingleOrder(customerId: string, orderId: string, skey: string) {
        this.myCartService.getsingleOrder(customerId, orderId, skey).subscribe(result => {
            this.cookieService.setCookieSession("savedOrder", JSON.stringify(result));
            if (this.cookieService.getCookie('savedOrder')) {
                let orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));

                this.cookieService.setCookieSession("OrderID", orderInfo.order_id);
                this.cookieService.setCookieSession('DataSources', JSON.stringify(orderInfo.data_sources));

                let centerLatlng: any;
                if (orderInfo.geometry.indexOf("|") != -1) {
                    let geomstring = "[" + (orderInfo.geometry).replace(/\|/g, ',') + "]";
                    this.cookieService.setCookieSession('selectedGeometry', geomstring);
                    let orderGeo = JSON.parse(geomstring);
                    centerLatlng = { lat: parseFloat(orderGeo[0][0][0][1]), lng: parseFloat(orderGeo[0][0][0][0]) };
                } else {
                    this.cookieService.setCookieSession('selectedGeometry', orderInfo.geometry);
                    let orderGeo = JSON.parse(orderInfo.geometry);

                    centerLatlng = { lat: parseFloat(orderGeo[0][0][1]), lng: parseFloat(orderGeo[0][0][0]) };
                }

                this.cookieService.setCookieSession('geoType', orderInfo.geometry_type);

                let savedAddress = orderInfo.address1 + " , " + orderInfo.city + " , " + orderInfo.provstate + " , " + orderInfo.postalzip + " , " + orderInfo.country;
                this.cookieService.setCookieSession("address", savedAddress);
                let inputAdd = orderInfo.address1
                let modifiedinput = inputAdd.replace(/,/g, '\U002C');
                this.cookieService.setCookieSession("userInput", modifiedinput);
                this.cookieService.setCookieSession("country", orderInfo.country);
                this.cookieService.setCookieSession("ProvState", orderInfo.provstate);
                this.cookieService.setCookieSession("homeZome", 16);

                this.cookieService.setCookieSession('Center', JSON.stringify(centerLatlng));

                let reqs = [
                    orderInfo.site_name,
                    orderInfo.contact_name

                ];
                this.cookieService.setCookieSession("reqInfo", JSON.stringify(reqs));
                let options = [
                    orderInfo.site_name,
                    orderInfo.contact_name,
                    orderInfo.project_num,
                    orderInfo.special_instructions,
                    orderInfo.alternate_email,
                    orderInfo.lot_building_size,
                    orderInfo.lot,
                    orderInfo.concession,
                    orderInfo.municipality,
                    orderInfo.legal_description,
                    orderInfo.land_use,
                    orderInfo.current_occupants,
                    orderInfo.past_occupants,

                ];
                this.cookieService.setCookieSession("optionInfo", JSON.stringify(options));
            }
            this.ngZone.run(() => {
                this.router.navigateByUrl('/package');
            })
        },
            error => this.orderConfirmation = error);
    }

    ngOnInit() {
        this.introService.setCheckoutOptions();
    }

    choseCreditCard(value: boolean): void {
        this.credit = value;
    }

    addOrderStatus(id: string, event) {
        let delayed = "";
        if ((event.target).checked) {

            delayed = "Y";
        } else {
            delayed = "N";
        }
        this.setDelay(this.username, id, delayed, this.sessionKey);
    }

    removeOrder(id: string) {
        this.deleteOrder(this.username, id, this.sessionKey);
    }

    editOrder(id: string): void {
        this.cookieService.clearAll();
        this.getsingleOrder(this.username, id, this.sessionKey);
    }
    continueOrder(): void {
        this.cookieService.clearAll();
    }
    setMaxNo(): void {
        let type = $('#cType :selected').text();
        if (type == 'American Express') {
            $("#cNumber").prop('maxLength', 15);
            $("#cCvv").prop('maxLength', 4);
        } else {
            $("#cNumber").prop('maxLength', 16);
            $("#cCvv").prop('maxLength', 3);
        }
    }
    placeOrder(cartData: any): void {

        $("#cNameTitle").css("color", "black");
        $("#cNumberTitle").css("color", "black");
        $("#cDateTitle").css("color", "black");

        if ($("#termChk").prop('checked')) {
            $("#termWarn").css('display', 'none');
            let allOrder = "";
            let cardInfo: any;
            if (this.credit) {
                cardInfo = "Credit";
            } else {
                cardInfo = "Invoice";
            }

            for (let order of cartData) {
                if ($("#" + order.ORDER_ID).prop('checked') == false) {
                    if (allOrder == "") {
                        allOrder = order.ORDER_ID;
                    } else {
                        allOrder += "," + order.ORDER_ID;
                    }
                }
            }

            this.placeorder(this.username, allOrder, cardInfo, this.sessionKey);

            $('#resModal').modal({
                backdrop: 'static',
                keyboard: false  // to prevent closing with Esc button (if you want this too)
            });
            $("#resModal").modal("show");
        } else {
            $("#termWarn").css('display', 'block');
        }
    }

    public canclePop(): void {
        $("#cancleModal").modal("show");
    }

    toNumber(evt): void {
        if (evt.which < 48 || evt.which > 57) {
            evt.preventDefault();
        }
    }
}
